import{anchorScroll as e}from"wix-rich-content-common";const c=l=>{const r=document.querySelectorAll("[data-editor]"),o=Array.apply(null,r).find(t=>t.dataset.offsetKey===`${l}-0-0`);o&&e(o)};export{c as scrollToBlock};
//# sourceMappingURL=scrollToBlock.js.map
